import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import {getToken,removeToken} from '@/auth'
import codeStatus from '@/errorCode'
import router from './router'
import { langConfig } from '@/lang/langConfig'
import { getStoreSysLang } from '@/lang/langUtils'

// 创建axios实例
const service = axios.create({
    baseURL: process.env.BASE_API, // api 的 base_url
    timeout: 50000 // 请求超时时间
})

// request拦截器  request  客户端向服务端发送端头
service.interceptors.request.use(
    config => {
        if(config.url.indexOf('/user/login/passportLogin') > -1){
            config.headers.Authorization = 'Basic enV1bDp6dXVs'
        }else{
            config.headers.Authorization = getToken()
        }
        config.headers.SYSTEM_TYPE = 5

        let sysLang = getStoreSysLang()
        const langConf = langConfig[sysLang]
        if (langConf) {
            let accepLang = langConf.extLang + (langConf.macroLang ? (',' + langConf.macroLang) : '')
            config.headers['Accept-Language'] = accepLang
        }
        return config
    },
    error => {
        // Do something with request error
        // console.log(error) // for debug
        Promise.reject(error)
    }
)

// response 拦截器   response   服务端向客户端发送端
service.interceptors.response.use(
    response => {
        /**
         * code为非1是抛错 可结合自己业务进行修改
         */
        return new Promise((resolve, reject) => {
            if(response.config.url.indexOf("/code/get") == -1){
                const res = response.data
                // console.log(res)
                // const status = Number(res.status) || Number(res.code) || 200;
                const status = Number(res.code)
                let message = res.msg || codeStatus.errorMsg[status] || codeStatus.errorMsg.default
                if(status == 500){
                    message = message + ',错误类型为' + res.msg
                }
                if (res.status === codeStatus.powerCode) {
                    localStorage.removeItem("token")
                    localStorage.removeItem("userInfo")
                    removeToken()
                    router.push({path: '/login'})

                    if (this.loading) {
                        this.loading = false
                    }

                    return reject(response)
                } else if (status == codeStatus.successCode) {
                    return resolve(res)
                } else if (status == codeStatus.businessCode) {
                    // if (this.loading){
                    //   this.loading = false
                    // }
                    return resolve(res)
                } else if (status !== codeStatus.successCode || status == codeStatus.errorCode || status == 500 || status == codeStatus.failCode) {

                    Message({
                        message: message,
                        type: 'error'
                    })
                    return reject(response)
                }
            }else {
                if(response.status == 200){
                    return resolve(response)
                }else{
                    alert("验证码获取错误")
                }

            }
        })


    },
    error => {
        return new Promise((resolve, reject) => {
            const status = Number(error.response.status)
            const message = codeStatus.errorMsg[status] || codeStatus.errorMsg.default || error.message + 'code=' + error.code

            if (window.MAINTENANCE_BULLETIN && status == window.MAINTENANCE_BULLETIN.status && window.MAINTENANCE_BULLETIN.url) {
                window.location.replace(window.MAINTENANCE_BULLETIN.url)
                error.response.data && Message({
                    message: error.response.data.msg,
                    type: 'error',
                    duration: 5 * 1000
                })
                return;
            }
            if (error.code == 'ECONNABORTED') {
                Message({
                    message: '对不起，请求超时！请重新尝试',
                    type: 'error',
                    duration: 5 * 1000
                })
            } else if (error.response.data.code == codeStatus.powerCode) {
                localStorage.removeItem("token")
                localStorage.removeItem("userInfo")
                removeToken()
                router.push({path: '/login'})
            } else {
                console.log(error)
                Message({
                    message: message,
                    type: 'error',
                    duration: 5 * 1000
                })
            }
            // console.log(typeof error)
            // console.log(error.response)
            // console.log(JSON.stringify(error))
            return reject(error.response)
        })
        // console.log('err' + error) // for debug

    }
)

let cancel
let promiseArr = {}
const CancelToken = axios.CancelToken
export default {
    // get请求
    get(obj) {
        return new Promise((resolve, reject) => {
            service({
                method: 'get',
                url: obj.url,
                params: obj.data,
                cancelToken: new CancelToken(c => {
                    cancel = c
                })
            }).then(res => {
                resolve(res)
                // console.log(res)
            }).catch(err=>{

                reject(err)

            })
        })
    },
    // post请求
    post(obj) {
        return new Promise((resolve, reject) => {
            service({
                method: 'post',
                url: obj.url,
                data: obj.data,
                cancelToken: new CancelToken(c => {
                    cancel = c
                })
            }).then(res => {
                resolve(res)
                // console.log(res)

            }).catch(err=>{
                reject(err)
            })
        })
    },
    // delete请求
    delete(obj) {
        return new Promise((resolve, reject) => {
            service({
                method: 'delete',
                url: obj.url,
                data: obj.data,
                cancelToken: new CancelToken(c => {
                    cancel = c
                })
            }).then(res => {
                resolve(res)
                // console.log(res)
            })
        })
    },
    // put请求
    put(obj) {
        return new Promise((resolve, reject) => {
            service({
                method: 'put',
                url: obj.url,
                data: obj.data,
                cancelToken: new CancelToken(c => {
                    cancel = c
                })
            }).then(res => {
                resolve(res)
                // console.log(res)
            })
        })
    }
}
